export const jobFunctionsSelector = (state) => state.jobFunctions;
export const allJobFunctionsSelector = (state) => state.allJobFunctions;
